export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Regular.woff?02271ec5cb9f5b4588ac53d7efbe6de8";